// extracted by mini-css-extract-plugin
module.exports = {"section":"faq-module--section--2-q0j","questions":"faq-module--questions--vU4xw","title":"faq-module--title--qrwCl","contact":"faq-module--contact--1_1j3"};